import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, P, useText } from "@sveabank/cc-common";

type Props = {
	isOpen: boolean;
	setOpen: (isOpen: boolean) => void;
};

const NoClcCandidateModal = ({ isOpen, setOpen }: Props) => {
	const [t, texts] = useText();
	return (
		<Dialog
			isOpen={isOpen}
			setOpen={setOpen}
			size="small"
			center
			heading={t(texts.newCompany.noClcCandidate.heading)}
			icon="warning"
		>
			<Dialog.Content>
				<P>{t(texts.newCompany.noClcCandidate.text)}</P>
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button onPress={() => setOpen(false)}>
						{t(texts.newCompany.noClcCandidate.buttonText)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};

export default NoClcCandidateModal;
